var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#131f2a",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,5.3418c-0.25587,0 -0.51203,0.09942 -0.70703,0.29492l-0.08594,0.08594c-0.391,0.391 -0.391,1.02406 0,1.41406l3.86328,3.86328h-13.07031c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1h13.07031l-3.86328,3.86328c-0.391,0.391 -0.391,1.02406 0,1.41406l0.08594,0.08594c0.391,0.391 1.02406,0.391 1.41406,0l5.65625,-5.65625c0.391,-0.391 0.391,-1.02406 0,-1.41406l-5.65625,-5.65625c-0.1955,-0.1955 -0.45116,-0.29492 -0.70703,-0.29492z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ArrowRight);
export default __webpack_public_path__ + "static/media/icons8-arrow-right.1f0fad16ddd9e62eb120227023a4545f.svg";
export { ForwardRef as ReactComponent };